// departmentSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createDepartemnt,
  deleteDepartment,
  fetchDepartment,
  updateDepartment,
} from "../../../services/departmentService";

export const fetchDepartmentAsync = createAsyncThunk(
  "department/fetchDepartment",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchDepartment();
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch department data"
      );
    }
  }
);

export const createDepartmentAsync = createAsyncThunk(
  "department/createDepartment",
  async (departmentData, { rejectWithValue }) => {
    try {
      const response = await createDepartemnt(departmentData);
      return response;
    } catch (error) {
      console.error("Error creating department:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateDepartmentAsync = createAsyncThunk(
  "department/updateDepartment",
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const response = await updateDepartment(id, updatedData);
      return response;
    } catch (error) {
      console.error("Error updating department:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const removeDepartment = createAsyncThunk(
  "department/removeDepartment",
  async (departmentId, { rejectWithValue }) => {
    try {
      await deleteDepartment(departmentId);
      return departmentId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState: {
    departmentData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchDepartmentAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDepartmentAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentData = action.payload;
      })
      .addCase(fetchDepartmentAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create
      .addCase(createDepartmentAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDepartmentAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentData.push(action.payload);
      })
      .addCase(createDepartmentAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateDepartmentAsync.fulfilled, (state, action) => {
        const index = state.departmentData.findIndex(
          (dept) => dept.department_Id === action.payload.department_Id
        );
        if (index !== -1) {
          state.departmentData[index] = action.payload;
        }
      })

      // Delete
      .addCase(removeDepartment.fulfilled, (state, action) => {
        state.departmentData = state.departmentData.filter(
          (item) => item.department_Id !== action.payload
        );
      });
  },
});

export default departmentSlice.reducer;
